import muster from '@dbk-legacy/muster';
import { getValues, ref } from '@dbk-legacy/muster/utils';

import calendar from './calendar';
import modal from './modal';

export default function calendarModal(calendarInitialState) {
  return muster()
    .require('onDone', { call: true })
    .path('onModalDone', {
      async call(_, { get, call }) {
        const [fromDate, toDate] = await getValues(get(['calendar.fromDate', 'calendar.toDate']));

        await call('onDone', { fromDate, toDate });
      },
    })
    .path('open', { call: (_, { call }) => call('modal.open') })
    .path('close', { call: (_, { call }) => call('modal.close') })
    .path('toggle', { call: (_, { call }) => call('modal.toggle') })
    .import('calendar', calendar(calendarInitialState))
    .import('modal', modal(), {
      onDone: ref('onModalDone'),
    });
}
